import '../style.css';

export const documentation_v1 = (
  <>
    <div className="my-3">
      <h1>Integração de ERP V1</h1>
      <p>
        Quando o fornecedor for integrado, a equipe de integração dará ao
        fornecedor uma API_KEY para acessar os endpoints da integração. A URL
        base de cada requisição comeca deste jeito:
        https://erp-integration-service.inventashop.com.br/api/v1/suppliers
        (base_url)
      </p>
      <p>A integração é composta por três fluxos:</p>
      <ol>
        <li>
          O primeiro é uma API para fornecedores. Esta API permite verificar se
          o fornecedor esta cadastrado dentro do fornecedor portal (FP) usando o
          CNPJ e a chave de acesso dele. A API também permite de criar um
          webhook para assinar e receber novos pedidos criados no ambiente
          Inventa.
        </li>
        <li>
          O segundo é uma API para receber as atualizações de pedido. Quando
          algum pedido é alterado no ERP do fornecedor, esta API deve ser
          chamada para atualizar este pedido no ambiente Inventa. A API também
          permite consultar pedidos de um fornecedor integrado usando o supplier
          ID correspondente. A consulta inclui a possibilidade de filtrar por
          estado, data de criação ou de atualização dos pedidos.
        </li>
        <li>
          O terceiro é uma API para receber atualizações de produto. Quando
          algum produto é alterado no ERP do fornecedor, esta API deve ser
          chamada para atualizar este produto no ambiente Inventa. A API também
          permite de consultar produtos cadastros pelo fornecedor usando o
          supplier ID correspondente.
        </li>
      </ol>
    </div>

    <div className="my-3">
      <h2>API de Fornecedor</h2>
      <p>
        Este endpoint é responsável por receber verificações de cadastro no FP e
        criação de webhook por pedidos.
      </p>

      <h3>Verificação de cadastro no FP</h3>
      <p>URL: base_url/supplier_id</p>
      <p>
        Esse endpoint permite verificar se o fornecedor foi cadastrado no FP,
        usando o método GET com a API_KEY. Caso o cadastro é registrado no FP,
        retornará o code 200 com um texto de sucesso.
      </p>
      <iframe
        src="https://erp-integration-service.inventa.dev.br/swagger-ui/index.html#/Integration%20Endpoints/getSupplierFromFPSupplier"
        width="100%"
        height={500}
        frameBorder="0"
      ></iframe>

      <h3>Webhook de pedidos</h3>
      <p>
        A URL da API que vai receber a requisição é persistida internamente de
        forma manual. Então quando algum fornecedor quiser receber os pedidos
        ele precisa enviar ao seu representante na Inventa a URL e uma API_KEY
        para autenticação na mesma.
      </p>
      <p>
        Para criar/atualizar o pedido, o serviço da Inventa enviará uma
        requisição POST/PUT para a URL cadastrada utilizando a chave de
        API(API_KEY) no cabeçalho da requisição e um payload JSON no corpo da
        requisição.
      </p>
      <iframe
        src="https://erp-integration-service.inventa.dev.br/swagger-ui/index.html#/Integration%20Endpoints/createWebhook"
        width="100%"
        height={500}
        frameBorder="0"
      ></iframe>
      <p>
        Nota: Requisição POST para criar e requisição PUT para atualizar. O
        status pode ser TO_BE_CONFIRMED, UNDER_REVIEW, CONFIRMED, NF_RECEIVED,
        SHIPPED, SHIPPING_CONFIRMED, DELIVERED, CANCELLED.
      </p>
    </div>

    <div className="my-3">
      <h2>API de Produto</h2>
      <p>
        Este endpoint é responsável por receber atualizações de produtos
        provenientes do ERP do fornecedor e acessar os produtos do fornecedor
        cadastrados na Inventa.
      </p>
      <p>
        A atualização pode ser de um único produto ou vários em massa. Veja
        abaixo um exemplo para cada caso.
      </p>

      <div className="my-3">
        <h3>Atualização de um único produto</h3>
        <p>
          Para atualizar o produto, precisamos usar o método PUT e passar o
          product_id(SKU) no endpoint, por exemplo [PUT] :
          base_url/supplier_id/products/product-id/
        </p>
        <p>
          O endpoint receberá a API_KEY no cabeçalho da requisição e os dados a
          serem atualizados no payload JSON no corpo.
        </p>
        <iframe
          src="https://erp-integration-service.inventa.dev.br/swagger-ui/index.html#/Product%20Endpoints/updateProduct"
          width="100%"
          height={500}
          frameBorder="0"
        ></iframe>
        <p>
          Nota: O status é opcional. Pode ser ATIVO, pode vender ou INATIVO, não
          aparece no site.
        </p>
      </div>

      <div className="my-3">
        <h3>Atualização do produto em massa</h3>
        <p>
          Para atualizar os produtos em massa, precisamos usar o método PUT e
          passar no endpoint como [PUT] : base_url/supplier_id/products/
        </p>
        <iframe
          src="https://erp-integration-service.inventa.dev.br/swagger-ui/index.html#/Product%20Endpoints/updateBatchProduct"
          width="100%"
          height={500}
          frameBorder="0"
        ></iframe>
        <p>
          O endpoint receberá a API_KEY no cabeçalho da requisição e os dados
          para atualizar no payload JSON no corpo como CURL abaixo.
        </p>
        <p>
          Nota: O status é opcional. Pode ser ATIVO, pode vender ou INATIVO, não
          aparece no site.
        </p>
      </div>
    </div>

    <div className="my-3">
      <h3>Acesso aos produtos</h3>
      <p>
        Para acessar os produtos cadastrados pelo fornecedor, precisamos usar o
        método GET e passar no endpoint como [GET] :
        base_url/supplier_id/products/
      </p>
      <p>
        O endpoint receberá a API_KEY no cabeçalho da requisição e retorna a
        lista dos produtos.
      </p>
      <iframe
        src="https://erp-integration-service.inventa.dev.br/swagger-ui/index.html#/Product%20Endpoints/getProducts"
        width="100%"
        height={500}
        frameBorder="0"
      ></iframe>
      <p>
        Nota: Filtros para refinar a requisição serão desenvolvidos em breve.
      </p>
    </div>

    <div className="my-3">
      <h2>API de Pedidos</h2>
      <p>
        Este endpoint é responsável por receber atualizações de pedidos
        provenientes do ERP do fornecedor e por acessar pedidos cadastrados na
        Inventa.
      </p>

      <p>
        A atualização e o acesso pode ser de um único pedido ou em massa. Veja
        abaixo um exemplo para cada caso.
      </p>

      <div className="my-3">
        <h3>Atualização de um único pedido</h3>
        <p>
          Para atualizar um único pedido, precisamos usar o método PUT e passar
          o order_id(NUMBER) no endpoint como [PUT] :
          base_url/supplier_id/orders/order-id/
        </p>
        <p>
          O endpoint receberá a API_KEY no cabeçalho da requisição e os dados a
          serem atualizados no payload JSON no corpo.
        </p>
        <iframe
          src="https://erp-integration-service.inventa.dev.br/swagger-ui/index.html#/Order%20Endpoints/updateOrder"
          width="100%"
          height={500}
          frameBorder="0"
        ></iframe>
        <p>
          Nota: O status pode ser TO_BE_CONFIRMED, UNDER_REVIEW, CONFIRMED,
          NF_RECEIVED, SHIPPED, SHIPPING_CONFIRMED, DELIVERED, CANCELLED.
        </p>
      </div>

      <div className="my-3">
        <h3>Atualização de pedidos em massa</h3>
        <p>
          Para atualizar os pedidos em massa, precisamos usar o método PUT como
          por exemplo [PUT] : base_url/supplier_id/orders
        </p>
        <p>
          O endpoint receberá a API_KEY no cabeçalho da requisição e os dados
          para atualizar no payload JSON no corpo.
        </p>
        <iframe
          src="https://erp-integration-service.inventa.dev.br/swagger-ui/index.html#/Order%20Endpoints/updateBatchOrder"
          width="100%"
          height={500}
          frameBorder="0"
        ></iframe>
        <p>
          Nota: O status pode ser TO_BE_CONFIRMED, UNDER_REVIEW, CONFIRMED,
          NF_RECEIVED, SHIPPED, SHIPPING_CONFIRMED, DELIVERED, CANCELLED.
        </p>
      </div>

      <div className="my-3">
        <h3>Acesso de um único pedido</h3>
        <p>
          Para acessar um único pedido, precisamos usar o método GET e passar um
          o order_id(NUMBER) no endpoint como [GET] :
          base_url/supplier_id/order-id
        </p>
        <iframe
          src="https://erp-integration-service.inventa.dev.br/swagger-ui/index.html#/Order%20Endpoints/getSingleOrder"
          width="100%"
          height={500}
          frameBorder="0"
        ></iframe>
        <p>
          O endpoint receberá a API_KEY no cabeçalho da requisição como CURL
          abaixo.
        </p>
      </div>
      <div className="my-3">
        <h3>Buscar pedidos</h3>
        <iframe
          src="https://erp-integration-service.inventa.dev.br/swagger-ui/index.html#/Order%20Endpoints/getOrders"
          width="100%"
          height={500}
          frameBorder="0"
        ></iframe>
        <p>
          Com os filtros implementados, é possivél refinar a busca de pedidos.
          Sem filtros, o método retornará os pedidos do ultimos 60 dias.
        </p>
        <p>
          É possivél refinar por estado, por data de criação ou por data de
          atualização. Também é possivél combinar uma data com um estado.
        </p>
        <p>
          Que seja por data de criação ou de atualização, fornecendo uma data de
          inicío retornará os pedidos desse periodo até hoje, caso a data for
          menos de 60 dias atrás. É possivél combinar esta data com estado para
          refinar mais a busca.
        </p>
        <p>
          Finalmente, fornecendo uma data de início e de fim, é possivél criar
          um periodo de busca. Esse periodo não pode se extender mais do que 60
          dias, mas oferece a possibilidade de buscar por pedidos mais antigos.
        </p>
      </div>

      <div className="my-3">
        <h4>Buscar pedidos por data de criação</h4>
        <p>
          Para acessar pedidos por data de criação, precisamos usar o método GET
          e passar no endpoint como parâmetro da requisição uma data de
          referência por exemplo [GET] :
          base_url/supplier_id/orders?created_date=2022-05-07
        </p>
        <p>O endpoint receberá a API_KEY no cabeçalho da requisição.</p>
        <p>Nota: É possivél combinar com o estado.</p>
      </div>

      <div className="my-3">
        <h4>Buscar pedidos por data de atualização</h4>
        <p>
          Para acessar pedidos por data de atualização, precisamos usar o método
          GET e passar no endpoint como parâmetro da requisição uma data de
          referência por exemplo [GET] :
          base_url/supplier_id/orders?updated_date=2022-05-07
        </p>
        <p>O endpoint receberá a API_KEY no cabeçalho da requisição.</p>
        <p>Nota: É possivél combinar com o estado.</p>
      </div>

      <div className="my-3">
        <h4>Buscar pedidos por estado</h4>
        <p>
          Para acessar pedidos por estado, precisamos usar o método GET e passar
          no endpoint como parâmetro da requisição uma data de referência por
          exemplo [GET] : base_url/supplier_id/orders?status=CONFIRMED
        </p>
        <p>O endpoint receberá a API_KEY no cabeçalho da requisição.</p>
        <p>
          Nota: O status pode ser TO_BE_CONFIRMED, UNDER_REVIEW, CONFIRMED,
          NF_RECEIVED, SHIPPED, SHIPPING_CONFIRMED, DELIVERED, CANCELLED.
        </p>
        <p>Nota: É possivél combinar com data de criação ou de atualização.</p>
      </div>

      <div className="my-3">
        <h4>Buscar pedidos por periodo</h4>
        <p>
          Para acessar pedidos por periodo, precisamos usar o método GET e
          passar no endpoint como parâmetro da requisição uma data de inicio e
          uma data de fim por exemplo [GET] :
          base_url/supplier_id/orders?created_date_start=2022-05-07?created_date_end=2022-05-14
        </p>
        <p>O endpoint receberá a API_KEY no cabeçalho da requisição.</p>
        <p>Nota: É possivél combinar com o estado.</p>
      </div>
    </div>
  </>
);
